import React from 'react';
import { useSelector } from 'react-redux';
import { statsLeadersBenchmarkingSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors';
import { BenchmarkingExplainer } from './BenchmarkingExplainer';
import { BenchmarkingLegend } from './BenchmarkingLegend';

export const BenchmarkingHeader = () => {
    const benchmarking = useSelector( statsLeadersBenchmarkingSelector );

    if ( !benchmarking.isActive ) {
        return <></>;
    }

    return (
        <div className="stats-leaders-benchmarking-header">
            <BenchmarkingLegend />
            <BenchmarkingExplainer />
        </div>
    );
};